/* eslint-disable react-hooks/exhaustive-deps */
import {
    DeleteOutlined,
    PaperClipOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import { Button, Divider, Form, Input, Select } from 'antd';
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useNotify from '../../../../context/Notification/useNotify';
import GlobalService from '../../../../services/Global.service';
import ModalDelete from '../../../../components/Shared/modal/delete';
import { useNavigate, useParams } from 'react-router-dom';
import { useBlocker } from '../../../../util/usePrompt';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import MyTaskService from '../../../../services/MyTask.service';
import DSRequestFormService from '../../../../services/DSRequestForm.service';

export default function DSFormEdit({
    item,
    customize,
    domainId,
    setEditMode,
    imageFile,
    setImageFile,
    docFile,
    setDocFile,
    fileTask,
    setFileList,
    getDSInformation,
}) {
    const navigate = useNavigate();
    const ref = useRef();
    let { dsrTaskId } = useParams();
    const { t, i18n } = useTranslation();
    const { Option } = Select;
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const notify = useNotify();

    const [personalTypeList, setPersonalTypeList] = useState([]);
    const [requestTypeList, setRequestTypeList] = useState([]);

    const [nextLocation, setNextLocation] = useState(null);
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [applicantRole, setApplicantRole] = useState();
    const [backAction, setBackAction] = useState(false);
    // const [imageFile, setImageFile] = useState();
    // const [docFile, setDocFile] = useState();
    const [deleteLoding, setDeleteLoding] = useState(false);
    const [openDelete, setOpenDelete] = useState({
        open: false,
        file: null,
    });
    const allowedType = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword', // .doc
        'application/pdf', // .pdf
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel', // .xls
        'image/png', // .png
        'image/jpeg', // .jepg
        'image/jpg', // .jepg
    ];

    // Get RequestType
    useEffect(() => {
        const getMasterDsRequuestForm = async () => {
            const { data } = await DSRequestFormService.getMasterDsRequuestForm(
                domainId
            );
            getRequestType(data?.resultData.detailsOfClaim);
        };
        const getRequestType = async (detailsOfClaim) => {
            try {
                const { data } = await GlobalService.getRequestType();
                const list = data?.resultData;
                const newList = [];
                for (const [key, value] of Object.entries(detailsOfClaim)) {
                    console.log(key);
                    const item = list?.filter(
                        (res) => res?.requestTypeId === value?.id
                    );
                    if (item.length > 0 && value?.status) {
                        newList.push(item[0]);
                    }
                }
                setRequestTypeList(newList);
            } catch (error) {}
        };
        getMasterDsRequuestForm();
    }, []);

    // Get PersonalType
    useEffect(() => {
        async function getPersonalType() {
            const { data } = await GlobalService.getDs();
            const dsTypeList = data?.resultData?.dataSubjectType;
            setPersonalTypeList(dsTypeList);
        }
        getPersonalType();
    }, []);

    useEffect(() => {
        form.setFieldsValue({
            ...item,
        });
        setApplicantRole(item?.applicantInformation?.applicantRole);
    }, []);

    const onChange = async (e) => {
        const files = e.target.files;
        if (files.length && files.length + fileTask.length <= 10) {
            const invalidFile = Array.from(files).find((file) => {
                const fileSize = file.size / 1024 / 1024;
                const fileType = file.type;
                if (fileSize >= 2) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Upload error file size is wrong'),
                    });
                    return true;
                }
                if (!allowedType.includes(fileType)) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Upload error file type is wrong'),
                    });
                    return true;
                }
                return false;
            });

            if (invalidFile) return;

            const allowedTypeDoc = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                'application/msword', // .doc
                'application/pdf', // .pdf
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel', // .xls
            ];
            const allowedTypeImage = [
                'image/png', // .png
                'image/jpeg', // .jepg
                'image/jpg', // .jepg
            ];

            let bodyFormDocData = new FormData();
            let imageList = [];
            let image = [];

            for (let file of files) {
                const fileType = file.type;
                let ImageData = new FormData();
                ImageData.append('image', file);
                ImageData.append('fileName', file.name);
                ImageData.append('action', 'image-create-application');

                if (allowedTypeImage.includes(fileType)) {
                    try {
                        const { data } = await GlobalService.uploadImage(
                            ImageData
                        );
                        if (data?.resultData?.imageId) {
                            const item = {
                                fileStorageId: data.resultData?.imageId,
                                fileName: data.resultData?.imageName,
                                fileType: data.resultData?.imageType,
                            };
                            image.push(data?.resultData);
                            imageList.push(item);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (allowedTypeDoc.includes(fileType)) {
                    const utf8Name = encodeURIComponent(file.name);
                    const header = `form-data; name="uploadFile"; filename*=UTF-8''${utf8Name}`;
                    bodyFormDocData.append('doc', file, header);
                }
            }

            setImageFile([...imageFile, ...image]);

            const docLength = Array.from(bodyFormDocData.keys()).length;
            let docFileList = [...docFile];
            let imageFileList = [...imageFile, ...imageList];

            if (docLength > 0) {
                bodyFormDocData.append('action', 'ds-request-step-4');
                try {
                    const { data } = await GlobalService.uploadDoc(
                        bodyFormDocData
                    );
                    if (data?.resultData) {
                        setDocFile([...docFile, ...data?.resultData]);
                        docFileList = [...docFile, ...data?.resultData];
                        imageList = imageList.concat(...data?.resultData);
                    }
                } catch (error) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: 'Failed to uploaded.',
                    });
                    console.log(error);
                }
            }

            setFileList([...fileTask, ...imageList]);
            updateFileList(docFileList, imageFileList);
        }
    };

    const updateFileList = async (docList, imageList) => {
        const payload = {
            dsrTaskId: dsrTaskId,
            domainId: item?.domainId,
            applicantInformation: item?.applicantInformation,
            dataSubjectInformation: {
                dataSubjectTypeId:
                    item?.dataSubjectInformation?.dataSubjectTypeId, // บทบาทผู้ยื่นคำร้อง
                firstName: item?.dataSubjectInformation?.firstName, // ชื่อ
                lastName: item?.dataSubjectInformation?.lastName, // นามสกุล
                address: item?.dataSubjectInformation?.address, // ที่อยู่
                phone: item?.dataSubjectInformation?.phone, // เบอร์โทร
                email: item?.dataSubjectInformation?.email, // อีเมล
                cardId: item?.dataSubjectInformation?.cardId, // หมายเลขบัตรประจำตัวประชาชน
                staffId: item?.dataSubjectInformation?.staffId, // รหัสพนักงาน
                remark: item?.dataSubjectInformation?.remark, // รายละเอียดอื่นๆ (ถ้ามี)
            },
            detailsOfClaim: {
                purpose: item?.detailsOfClaim?.purpose,
                requestTypeId: item?.detailsOfClaim?.requestTypeId,
                personalLocation: item?.detailsOfClaim?.personalLocation,
                reason: item?.detailsOfClaim?.reason,
            },
            evidenceInformation: {
                filesDoc: docList,
                filesImage: imageList,
            },
        };
        try {
            await MyTaskService.editDSInformation(payload);
            getDSInformation();
        } catch (error) {}
    };

    const onInputClick = (event) => {
        event.target.value = '';
    };

    const deleteFile = async (file) => {
        const imageType = [
            'png', // .png
            'jpeg', // .jepg
            'jpg', // .jepg
        ];
        const id = file?.fileStorageId;
        if (imageType.includes(file?.fileType)) {
            await GlobalService.deleteImage(id)
                .then((res) => {
                    setDeleteLoding(false);
                    if (res.data.resultCode === 1) {
                        setOpenDelete({
                            open: false,
                            file: null,
                        });
                        setImageFile(
                            imageFile.filter((file) => file.imageId !== id)
                        );
                        setFileList(
                            fileTask.filter((file) => file.fileStorageId !== id)
                        );
                    }
                })
                .catch((error) => {
                    setDeleteLoding(false);
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to deleted'),
                    });
                });
        } else {
            await GlobalService.deleteFile(id)
                .then((res) => {
                    setDeleteLoding(false);
                    if (res.data.resultCode === 1) {
                        setOpenDelete({
                            open: false,
                            file: null,
                        });
                        setDocFile(
                            docFile.filter((file) => file.fileStorageId !== id)
                        );
                        setFileList(
                            fileTask.filter((file) => file.fileStorageId !== id)
                        );
                    }
                })
                .catch((error) => {
                    setDeleteLoding(false);
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to deleted'),
                    });
                });
        }
    };

    const downloadFile = async (file) => {
        const imageType = [
            'png', // .png
            'jpeg', // .jepg
            'jpg', // .jepg
        ];
        if (imageType.includes(file?.fileType)) {
            await GlobalService.getImage(file?.fileStorageId).then((res) => {
                const itemImg = `data:image/${file?.fileType};base64,${res?.data?.resultData?.imageId}`;
                // `data:image/png;base64,${data.resultData?.imageId}`
                if (res.data) {
                    const objectURL = itemImg;
                    const link = document.createElement('a');
                    link.href = objectURL;
                    link.download = file?.fileName + '.' + file.fileType;
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
            });
        } else {
            await GlobalService.downloadDoc(file?.fileStorageId).then((res) => {
                if (res.data) {
                    const objectURL = URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = objectURL;
                    link.download = file?.fileName + '.' + file.fileType;
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
            });
        }
    };

    const onFinish = async (value) => {
        const dsInfoCase1 = {
            dataSubjectTypeId: value?.dataSubjectInformation?.dataSubjectTypeId, // บทบาทผู้ยื่นคำร้อง
            firstName: item?.dataSubjectInformation?.firstName, // ชื่อ
            lastName: item?.dataSubjectInformation?.lastName, // นามสกุล
            address: item?.dataSubjectInformation?.address, // ที่อยู่
            phone: item?.dataSubjectInformation?.phone, // เบอร์โทร
            email: item?.dataSubjectInformation?.email, // อีเมล
            cardId: item?.dataSubjectInformation?.cardId, // หมายเลขบัตรประจำตัวประชาชน
            staffId: item?.dataSubjectInformation?.staffId, // รหัสพนักงาน
            remark: item?.dataSubjectInformation?.remark, // รายละเอียดอื่นๆ (ถ้ามี)
        };
        const dsInfoCase2 = {
            dataSubjectTypeId: value?.dataSubjectInformation?.dataSubjectTypeId, // บทบาทผู้ยื่นคำร้อง
            firstName: value?.dataSubjectInformation?.firstName, // ชื่อ
            lastName: value?.dataSubjectInformation?.lastName, // นามสกุล
            address: value?.dataSubjectInformation?.address, // ที่อยู่
            phone: value?.dataSubjectInformation?.phone, // เบอร์โทร
            email: value?.dataSubjectInformation?.email, // อีเมล
            cardId: value?.dataSubjectInformation?.cardId, // หมายเลขบัตรประจำตัวประชาชน
            staffId: value?.dataSubjectInformation?.staffId, // รหัสพนักงาน
            remark: value?.dataSubjectInformation?.remark, // รายละเอียดอื่นๆ (ถ้ามี)
        };
        const payload = {
            dsrTaskId: dsrTaskId,
            domainId: item?.domainId,
            applicantInformation: {
                ...value?.applicantInformation,
                purpose: value?.applicantInformation?.purpose || null,
            },
            dataSubjectInformation:
                item?.applicantInformation?.applicantRole === 0
                    ? dsInfoCase1
                    : dsInfoCase2,
            detailsOfClaim: value?.detailsOfClaim,
            evidenceInformation: {
                filesDoc: docFile,
                filesImage: imageFile,
            },
        };
        try {
            const { data } = await MyTaskService.editDSInformation(payload);
            if (data?.resultCode === 1) {
                setBackAction(true);
                setEditMode(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
            }
        } catch (error) {}
    };

    const handelOkChange = async () => {
        await setChange(false);
        await setOpenChange(false);
        await form.resetFields();
        setEditMode(false);
        navigate(nextLocation.location.pathname + nextLocation.location.search);
    };

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setNextLocation(nextLocation);
    };

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                onFinish={onFinish}
                // validateMessages={validateMessages}
                layout="vertical"
                className="px-2"
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0 && !backAction) {
                        setChange(true);
                    }
                }}
            >
                <div className="flex justify-end pb-2">
                    <div className="flex gap-x-3">
                        <Button
                            type="default"
                            size="large"
                            className="w-[120px] border-[#7B67FB] text-[#7B67FB]"
                            onClick={() => {
                                if (change) {
                                    setBackAction(true);
                                    setOpenChange(true);
                                } else {
                                    setEditMode(false);
                                }
                            }}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            htmlType="submit"
                            className="w-[120px]"
                            // onClick={() => setEditMode(false)}
                        >
                            {t('common.Submit')}
                        </Button>
                    </div>
                </div>
                <div className="text-xl font-medium">
                    {t('MyTask.DSInformation')}
                </div>
                <Divider className="my-2" />
                <div className="overflow-auto h-[70vh] px-3">
                    <div>
                        <Form.Item
                            label={t('MyTask.PetitionerRole')}
                            name={['applicantInformation', 'applicantRole']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Select disabled size="large" placeholder="">
                                <Option key={0} value={0}>
                                    {t('MyTask.Role1')}
                                </Option>
                                <Option key={1} value={1}>
                                    {t('MyTask.Role2')}
                                </Option>
                            </Select>
                        </Form.Item>
                        {applicantRole === 1 && (
                            <Form.Item
                                label={t('MyTask.Purpose')}
                                name={['applicantInformation', 'purpose']}
                                rules={[
                                    {
                                        required:
                                            applicantRole === 1 ? true : false,
                                        message: t('errorText.requiredField'),
                                    },
                                ]}
                            >
                                <TextArea
                                    size="large"
                                    autoSize={{ minRows: 4, maxRows: 4 }}
                                ></TextArea>
                            </Form.Item>
                        )}
                        <div className="text-[#7B67FB] font-semibold text-sm">
                            {t('MyTask.PetitionerInformation')}
                        </div>
                        <Form.Item
                            label={t('MyTask.Name')}
                            name={['applicantInformation', 'firstName']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input size="large"></Input>
                        </Form.Item>
                        <Form.Item
                            label={t('MyTask.LastName')}
                            name={['applicantInformation', 'lastName']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input size="large"></Input>
                        </Form.Item>
                        <Form.Item
                            label={t('MyTask.Address')}
                            name={['applicantInformation', 'address']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                autoSize={{ minRows: 4, maxRows: 4 }}
                            ></TextArea>
                        </Form.Item>
                        <Form.Item
                            label={t('MyTask.Phone')}
                            name={['applicantInformation', 'phone']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input size="large"></Input>
                        </Form.Item>
                        <Form.Item
                            label={t('MyTask.Email')}
                            name={['applicantInformation', 'email']}
                            rules={[
                                {
                                    type: 'email',
                                    message:
                                        i18n.language === 'th'
                                            ? 'กรุณากรอกข้อมูลให้ถูกต้อง'
                                            : 'Email is not a valid.',
                                },
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input size="large"></Input>
                        </Form.Item>
                        <Form.Item
                            label={t('MyTask.IdCard')}
                            name={['applicantInformation', 'cardId']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input maxLength={13} size="large"></Input>
                        </Form.Item>
                        <Form.Item
                            label={t('MyTask.Remark')}
                            name={['applicantInformation', 'remark']}
                        >
                            <TextArea
                                size="large"
                                autoSize={{ minRows: 4, maxRows: 4 }}
                            ></TextArea>
                        </Form.Item>
                        <div className="text-[#7B67FB] font-semibold text-sm">
                            {t('MyTask.PersonalDataSubjectInformation')}
                        </div>
                        <Form.Item
                            label={t('MyTask.DataSubjectType')}
                            name={[
                                'dataSubjectInformation',
                                'dataSubjectTypeId',
                            ]}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Select disabled size="large" placeholder="">
                                {personalTypeList?.map((res) => (
                                    <Option key={res?.id} value={res?.id}>
                                        {i18n.language === 'en'
                                            ? res?.nameEn
                                            : res?.nameTh}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {true && (
                            <>
                                <Form.Item
                                    label={t('MyTask.Name')}
                                    name={[
                                        'dataSubjectInformation',
                                        'firstName',
                                    ]}
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Input size="large"></Input>
                                </Form.Item>
                                <Form.Item
                                    label={t('MyTask.LastName')}
                                    name={[
                                        'dataSubjectInformation',
                                        'lastName',
                                    ]}
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Input size="large"></Input>
                                </Form.Item>
                                <Form.Item
                                    hidden={!customize?.display?.address}
                                    label={t('MyTask.Address')}
                                    name={['dataSubjectInformation', 'address']}
                                    rules={[
                                        {
                                            required:
                                                customize?.display?.address,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <TextArea
                                        size="large"
                                        autoSize={{ minRows: 4, maxRows: 4 }}
                                    ></TextArea>
                                </Form.Item>
                                <Form.Item
                                    hidden={!customize?.display?.phone}
                                    label={t('MyTask.Phone')}
                                    name={['dataSubjectInformation', 'phone']}
                                    rules={[
                                        {
                                            // ^[0-9]\d*$
                                            pattern: new RegExp(/^[0-9]\d*$/),
                                            message:
                                                i18n.language === 'th'
                                                    ? 'กรุณากรอกข้อมูลให้ถูกต้อง'
                                                    : 'Phone is not a valid.',
                                        },
                                        {
                                            required: customize?.display?.phone,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Input size="large"></Input>
                                </Form.Item>
                                <Form.Item
                                    label={t('MyTask.Email')}
                                    name={['dataSubjectInformation', 'email']}
                                    rules={[
                                        {
                                            type: 'email',
                                            message:
                                                i18n.language === 'th'
                                                    ? 'กรุณากรอกข้อมูลให้ถูกต้อง'
                                                    : 'Email is not a valid.',
                                        },
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Input size="large"></Input>
                                </Form.Item>
                                <Form.Item
                                    hidden={!customize?.display?.cardId}
                                    label={t('MyTask.IdCard')}
                                    name={['dataSubjectInformation', 'cardId']}
                                    rules={[
                                        {
                                            required:
                                                customize?.display?.cardId,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Input maxLength={13} size="large"></Input>
                                </Form.Item>
                                <Form.Item
                                    hidden={!customize?.display?.staffId}
                                    label={t('MyTask.StaffID')}
                                    name={['dataSubjectInformation', 'staffId']}
                                    rules={[
                                        {
                                            required:
                                                customize?.display?.staffId,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Input size="large"></Input>
                                </Form.Item>
                                <Form.Item
                                    hidden={!customize?.display?.detail}
                                    label={t('MyTask.Remark')}
                                    name={['dataSubjectInformation', 'remark']}
                                >
                                    <TextArea
                                        size="large"
                                        autoSize={{ minRows: 4, maxRows: 4 }}
                                    ></TextArea>
                                </Form.Item>
                            </>
                        )}
                        <div className="text-[#7B67FB] font-semibold text-sm">
                            {t('MyTask.DetailOfRequest')}
                        </div>
                        <Form.Item
                            label={t('MyTask.PersonalDataRequestedForRights')}
                            name={['detailsOfClaim', 'purpose']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                autoSize={{ minRows: 4, maxRows: 4 }}
                            ></TextArea>
                        </Form.Item>
                        <Form.Item
                            label={t('MyTask.RequestType')}
                            name={['detailsOfClaim', 'requestTypeId']}
                        >
                            <Select disabled size="large" placeholder="">
                                {requestTypeList?.map((res) => (
                                    <Option
                                        key={res?.requestTypeId}
                                        value={res?.requestTypeId}
                                    >
                                        {res?.requestTypeShortName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            hidden={!customize?.display?.personalLocation}
                            label={t('MyTask.PesonalDataLocation')}
                            name={['detailsOfClaim', 'personalLocation']}
                            // rules={[
                            //     {
                            //         required: customize?.display?.personalLocation,
                            //         message: t('errorText.requiredField'),
                            //     },
                            // ]}
                        >
                            <TextArea
                                size="large"
                                autoSize={{ minRows: 4, maxRows: 4 }}
                            ></TextArea>
                        </Form.Item>
                        <Form.Item
                            label={t(
                                'MyTask.DetailsOfRequestingRightsAndReasonsForRequesting'
                            )}
                            name={['detailsOfClaim', 'reason']}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <TextArea
                                size="large"
                                autoSize={{ minRows: 4, maxRows: 4 }}
                            ></TextArea>
                        </Form.Item>
                        <div className="text-[#7B67FB] font-semibold text-sm">
                            {t('MyTask.EvidenceInformation')}
                        </div>
                        <div className="font-semibold">
                            {t('MyTask.ProofOfIdentity')} :{' '}
                            <div className="font-normal">
                                <ul
                                    className="list-outside"
                                    style={{ paddingInlineStart: '30px' }}
                                >
                                    {item?.evidenceInformation?.proofOfIdentity.map(
                                        (res) => (
                                            <li
                                                key={res?.id}
                                                hidden={
                                                    res?.id ===
                                                    '0ecb41743d7111edb8780242ac120002'
                                                }
                                                className="whitespace-pre-line"
                                            >
                                                {res?.name}
                                            </li>
                                        )
                                    )}
                                    {item?.evidenceInformation
                                        ?.proofOfIdentityAddon && (
                                        <li className="whitespace-pre-line">
                                            {
                                                item?.evidenceInformation
                                                    ?.proofOfIdentityAddon
                                            }
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <Form.Item
                            name="files"
                            label={
                                <div className="font-semibold">
                                    {t('MyTask.Files')}
                                </div>
                            }
                        >
                            <>
                                <div className="border-solid border border-blue-400 rounded-md min-h-[112px] px-2">
                                    <label
                                        onClick={() => ref.current.click()}
                                        className={'cursor-pointer'}
                                    >
                                        <Button
                                            className="mt-2 border-dashed border border-sky-300 text-sky-500 bg-sky-50 mb-2"
                                            icon={<PlusCircleOutlined />}
                                        >
                                            {t('MyTask.ChooseFile')}
                                        </Button>
                                        <input
                                            ref={ref}
                                            disabled={fileTask?.length === 10}
                                            onChange={onChange}
                                            onClick={onInputClick}
                                            type="file"
                                            style={{ display: 'none' }}
                                            multiple
                                            accept={allowedType.join(',')}
                                            // value={valueInput}
                                        />
                                    </label>
                                    <div className="py-2">
                                        {fileTask?.map((file, i) => {
                                            return (
                                                <div
                                                    key={file.fileStorageId}
                                                    className="flex justify-between"
                                                >
                                                    <button
                                                        type="button"
                                                        className="text-new space-x-2 cursor-pointer w-[94%] flex items-start"
                                                        onClick={() =>
                                                            downloadFile(file)
                                                        }
                                                    >
                                                        <PaperClipOutlined className="pt-1" />
                                                        <div
                                                            className="overflow-hidden font-semibold"
                                                            style={{
                                                                wordWrap:
                                                                    'break-word',
                                                            }}
                                                        >
                                                            {file.fileName}.
                                                            {file.fileType}
                                                        </div>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setOpenDelete({
                                                                open: true,
                                                                file: file,
                                                            });
                                                        }}
                                                        className="text-[#95A0A8] cursor-pointer"
                                                    >
                                                        <DeleteOutlined />
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className="text-10 text-[#95A0A8] pt-1">
                                    * {t('fileHinTitle')} <br />(
                                    {t('fileHinDes')})
                                </div>
                            </>
                        </Form.Item>
                    </div>
                </div>
            </Form>

            <ModalDelete
                loading={deleteLoding}
                open={openDelete?.open}
                handelClose={() => {
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                }}
                handelOk={() => {
                    setDeleteLoding(true);
                    const file = openDelete.file;
                    deleteFile(file);
                }}
            />
            <ModalDiscardChanges
                open={openChange}
                handelOk={handelOkChange}
                handelClose={() => setOpenChange(false)}
            />
        </>
    );
}
